<template>
  <LayerOverlay
    ref="overlay"
    :dismissible="!unclosable && !persistent"
    :maximized="maximized"
    @hide="$emit('hide')"
  >
    <template v-if="maximized">
      <slot />
    </template>

    <q-card
      v-else
      class="modal__card"
      :class="cardCssClass"
      role="dialog"
      aria-modal="true"
    >
      <template v-if="title">
        <q-toolbar>
          <q-toolbar-title>
            {{ title }}
          </q-toolbar-title>
          <q-btn
            v-if="!unclosable"
            flat
            round
            @click="hide"
          >
            <q-icon name="fa fa-times" />
          </q-btn>
        </q-toolbar>

        <q-separator />
      </template>

      <q-card-section
        class="modal__card__body custom-scrollbar"
        :style="bodyStyle"
      >
        <slot />
      </q-card-section>

      <q-separator />

      <q-card-actions align="right">
        <q-btn
          v-if="!unclosable && !$slots.actions"
          flat
          @click="hide"
        >
          Close
        </q-btn>
        <slot name="actions" :hide="hide" :show="show" />
      </q-card-actions>
    </q-card>
  </LayerOverlay>
</template>

<style lang="scss">
@import '../../styles/quasar.variables';

.modal {
  max-width: none;

  &__card {
    display: flex;
    flex-direction: column;
    max-width: none !important;
    max-height: 100%;
    width: 100%;

    @media screen and (min-width: 380px) {
      &--xs {
        width: 380px;
      }
    }

    @media screen and (min-width: $breakpoint-sm-min) {
      &--sm {
        width: $breakpoint-sm-min;
      }
    }

    @media screen and (min-width: $breakpoint-md-min) {
      &--md {
        width: $breakpoint-md-min;
      }
    }

    @media screen and (min-width: $breakpoint-lg-min) {
      &--lg {
        width: $breakpoint-lg-min;
      }
    }

    &__body {
      flex-grow: 1;
      overflow-y: auto;
    }
  }
}
</style>

<script>
import LayerOverlay from '@/components/LayerOverlay.vue';

export default {
  components: { LayerOverlay },
  emits: ['hide'],
  props: {
    title: {
      type: String,
      required: false,
    },
    size: {
      type: String,
      default: 'sm',
    },
    maximized: {
      type: Boolean,
      default: false,
    },
    unclosable: {
      type: Boolean,
      default: false,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    bodyStyle: [String, Object, Array],
  },
  computed: {
    cardCssClass() {
      return `modal__card--${this.size}`;
    },

  },
  methods: {
    show() {
      this.$refs.overlay.show();
    },
    hide() {
      this.$refs.overlay.hide();
    },
  },
};
</script>
